import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../components/Button';
import { AuthContext } from '../../../../../contexts/AuthContext';
import {
  Modules,
  AuthRoutes,
  RouteParamsTypes,
  PermissionModulesEnum,
  PermissionActionsEnum,
} from '../../../../../enums';
import { hasResourseAccess } from '../../../../../utils/methods';

interface HeaderProps {
  id?: string;
  view: boolean;
  edit: boolean;
}

const Header: React.FC<HeaderProps> = ({ id, view, edit }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isSystemAdmin, permissions } = useContext(AuthContext);

  const hasAddAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.Users]: [PermissionActionsEnum.Add] }],
  });
  const hasEditAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.Users]: [PermissionActionsEnum.Update] }],
  });
  const hasListAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.Users]: [PermissionActionsEnum.View] }],
  });

  const handleGoToListClick = () => {
    navigate(Modules.resources + AuthRoutes.users);
  };

  const handleEditButtonClick = () => {
    navigate(`${Modules.resources}${AuthRoutes.users}${RouteParamsTypes.edit}/${id}`);
  };

  const handleAddNewClick = () => {
    navigate(Modules.resources + AuthRoutes.users + RouteParamsTypes.add);
  };

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{t('users.addEdit.pageTexts.header.title')}</h4>
        <p>{t('users.addEdit.pageTexts.header.subTitle')}</p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end">
        <div>
          {hasListAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light me-3"
              onClick={handleGoToListClick}
              text={t('users.addEdit.pageTexts.header.goToList')}
            />
          )}

          {edit && hasAddAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light mt-xs-3"
              text={t('users.addEdit.pageTexts.header.addNew')}
              onClick={handleAddNewClick}
            />
          )}

          {view && hasEditAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light mt-xs-3"
              text={t('users.addEdit.pageTexts.header.editBtn')}
              onClick={() => handleEditButtonClick()}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
